import * as React from "react";
import { connect } from "react-redux";

import { Grid } from "tabler-react";
import { bindActionCreators } from "redux";

import { IJob } from "types/job";
import JobDetailsCard from "./JobDetailsCard.react";
import JobApplyCard from "./JobDetailsApplyCard.react";
import LoginModal from "../Login";
import JobApplyWithoutRegistration from "../JobApplyWithoutRegistration";
import RegisterModal from "../Register";
import {
  applyWithoutRegistration,
  applyForJob,
  userJobStatus,
  openAlert,
  resetJobApplyForm,
  resetJobApplyModal,
} from "../../actions";

export interface Props {
  recentJobs: any;
  auth: any;
  openAlert: any;
  applyWithoutRegister: any;
  resetJobApplyForm: any;
  resetJobApplyModal: any;
  getJobsDetails: (number) => {};
  jobDetails: IJob;
  match: any;
  applyWithoutRegistration: any;
  applyForJob: any;
  userJobStatus: any;
  userJobApplicationStatus: any;
  location: any;
}

interface State {
  isOpenApplyModal: boolean;
  openLogin: boolean;
  openRegister: boolean;
  isSubmitting: boolean;
  isSubmitted: boolean;
}

class JobDetails extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.openApplyModal = this.openApplyModal.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.openLoginModal = this.openLoginModal.bind(this);
    this.openRegisterModal = this.openRegisterModal.bind(this);
    this.applyJob = this.applyJob.bind(this);

    this.state = {
      isOpenApplyModal: false,
      openLogin: false,
      openRegister: false,
      isSubmitting: false,
      isSubmitted: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.applyWithoutRegister.success && this.state.isSubmitting) {
      this.setState({
        isSubmitting: false,
        isSubmitted: true,
      });
    }
    if (nextProps.jobApplied.success && this.state.isSubmitting) {
      this.setState({
        isSubmitting: false,
      });
      this.props.userJobStatus({
        job: this.props.jobDetails.id,
      });
    }
  }

  componentWillMount() {
    // this.props.userJobStatus({
    //   job: this.props.jobDetails[0].id
    // })
  }
  openApplyModal() {
    this.setState({
      isOpenApplyModal: true,
      openLogin: false,
      openRegister: false,
      isSubmitting: false,
      isSubmitted: false,
    });
  }

  openRegisterModal() {
    this.setState({
      isOpenApplyModal: false,
      openLogin: false,
      openRegister: true,
      isSubmitting: false,
      isSubmitted: false,
    });
  }

  openLoginModal() {
    this.setState({
      isOpenApplyModal: false,
      openLogin: true,
      openRegister: false,
      isSubmitting: false,
      isSubmitted: false,
    });
  }

  handleClose() {
    this.setState({
      isOpenApplyModal: false,
      openLogin: false,
      openRegister: false,
      isSubmitting: false,
      isSubmitted: false,
    });
    this.props.resetJobApplyForm();
    this.props.resetJobApplyModal();
  }

  applyJob() {
    this.setState({
      isSubmitting: true,
    });
    let obj = {
      job: this.props.jobDetails.id,
    };
    this.props.applyForJob(obj);
  }

  render() {
    const isAuthenticated = this.props.auth
      ? this.props.auth.isAuthenticated
      : this.props.auth;
    const { userJobApplicationStatus, recentJobs, jobDetails } = this.props;

    return (
      <React.Fragment>
        <Grid.Row className="container margin-auto margin-top-15">
          <Grid.Col lg={9} md={9} xs={12} className="padding-none">
            <JobDetailsCard
              applyJob={this.applyJob}
              jobDetails={this.props.jobDetails}
              isAuth={isAuthenticated}
              isApplied={
                userJobApplicationStatus.status
                  ? userJobApplicationStatus.isUserApplied
                  : false
              }
              openApplyModal={this.openApplyModal}
              openRegister={this.openRegisterModal}
              openLogin={this.openLoginModal}
            />
          </Grid.Col>
          <Grid.Col lg={3} md={3} xs={12} className="job-details-sidebar">
            <JobApplyCard
              isLogged={isAuthenticated}
              isApplied={
                userJobApplicationStatus.status
                  ? userJobApplicationStatus.isUserApplied
                  : false
              }
              openApplyModal={this.openApplyModal}
              openRegister={this.openRegisterModal}
              openLogin={this.openLoginModal}
              applyJob={this.applyJob}
              recentJobs={recentJobs.filter((job) => job.id != jobDetails.id)}
            />
          </Grid.Col>
        </Grid.Row>
        <LoginModal
          open={this.state.openLogin}
          onRegisterLinkClicked={this.openRegisterModal}
          onForgotPasswordClicked={null}
          handleClose={this.handleClose}
        />
        <JobApplyWithoutRegistration
          isSubmitting={this.state.isSubmitting}
          open={this.state.isOpenApplyModal}
          handleClose={this.handleClose}
          isSubmitted={this.state.isSubmitted}
          job={this.props.jobDetails}
        />
        <RegisterModal
          open={this.state.openRegister}
          onLoginLinkClicked={this.openLoginModal}
          handleClose={this.handleClose}
          handleUploadResume={null}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    applyWithoutRegister: state.applyWithoutRegister,
    userJobApplicationStatus: state.userJobStatus,
    jobApplied: state.jobApplied,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      applyWithoutRegistration,
      applyForJob,
      userJobStatus,
      openAlert,
      resetJobApplyForm,
      resetJobApplyModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(JobDetails);
